// extracted by mini-css-extract-plugin
export default {"dark-background":"BannerSection_dark-background__4MJGr","player-overlay":"BannerSection_player-overlay__y+0f3","section":"BannerSection_section__fR7im"};